import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // Importe o registro
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom'; // Importar BrowserRouter
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './UserContext'; // Import the provider
import { AuthProvider } from './context/AuthContext'; // Importar AuthProvider
import { PacienteProvider } from './PacienteContext'; // Importe o provedor
import { AlertModalProvider } from './AlertModalContext'; // 1. Importar o AlertModalProvider
import { EntidadeProvider } from './EntidadeContext'; // Importar o novo provider
import { FontSizeProvider } from './context/FontSizeContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* BrowserRouter envolve toda a aplicação */}
      <AlertModalProvider> {/* 2. Mover o AlertModalProvider para envolver todos os outros */}
        <AuthProvider>
          <EntidadeProvider>
            <UserProvider>
              <PacienteProvider>
                <FontSizeProvider>
                  <App />
                </FontSizeProvider>
              </PacienteProvider>
            </UserProvider>
          </EntidadeProvider>
        </AuthProvider>
      </AlertModalProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals_
// O sistema depende da API online e não deve manter bundles antigos em cache.
// Também remove automaticamente Service Workers de versões anteriores.
serviceWorkerRegistration.unregister();
reportWebVitals();
